import React from 'react';
import { Link, Button, EThemes } from '@expert360/ui';
import styles from './index.module.css';

const showIntercomMessage = (e: React.MouseEvent<HTMLElement>) => {
  if ('Intercom' in window) {
    e.preventDefault();
    (window as any).Intercom('showNewMessage');
  }
};

interface GetInTouchButtonProps {
  buttonLinks?: boolean;
}

export default function GetInTouchButton({
  buttonLinks = false,
}: GetInTouchButtonProps) {
  if (buttonLinks) {
    if (typeof window === 'undefined') {
      return (
        <Link theme="buttonSecondary" className={styles.linkPadding}>
          <a href="mailto:info@expert360.com">Get in touch</a>
        </Link>
      );
    }

    return (
      <Button
        theme={EThemes.Secondary}
        type="button"
        onClick={showIntercomMessage}
      >
        Get in touch
      </Button>
    );
  } else {
    if (typeof window === 'undefined') {
      return (
        <a
          className="c-button-faux c-button-faux--inline c-button-faux--size-base"
          href="mailto:info@expert360.com"
        >
          get in touch
        </a>
      );
    }

    return (
      <button
        className="c-button-faux c-button-faux--inline c-button-faux--size-base"
        type="button"
        onClick={showIntercomMessage}
      >
        get in touch
      </button>
    );
  }
}
